import React from 'react';

import { useDesignVersion } from '../../context/useDesignVersion';

type DesignRouteProps = {
  legacy: React.ReactNode;
  modern: React.ReactNode;
};

const DesignRoute: React.FC<DesignRouteProps> = ({ legacy, modern }) => {
  const { isModernDesign } = useDesignVersion();
  return <>{isModernDesign ? modern : legacy}</>;
};

export default DesignRoute;
